import { useRef } from 'react';

import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';
import { Hint, Label, Error } from '@progress/kendo-react-labels';

export const FormDropDown = (fieldRenderProps: FieldRenderProps) => {
  const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, className, optional, required, ...others } =
    fieldRenderProps;
  const editorRef = useRef(null);

  const showValidationMessage: string | false | null = touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : '';
  const errorId: string = showValidationMessage ? `${id}_error` : '';
  const labelId: string = label ? `${id}_label` : '';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (event: any) => {
    event.value = others.valueMap ? others.valueMap(event.value) : event.value;
    others.onChange(event);
  };

  const valueItem =
    others.valueMap && others.value !== null && others.value !== undefined
      ? others.data.find((x: any) => others.valueMap(x) === others.value)
      : others.value;

  return (
    <FieldWrapper className={className} style={wrapperStyle}>
      {!others.hideLabel && (
        <Label
          id={labelId}
          editorRef={editorRef}
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
          className={`${required ? 'required' : null}`}
        >
          {label}
        </Label>
      )}
      <div className={'k-form-field-wrap'}>
        <DropDownList
          ariaLabelledBy={labelId}
          ariaDescribedBy={`${hintId} ${errorId}`}
          ref={editorRef}
          valid={valid}
          id={id}
          disabled={disabled}
          {...others}
          value={valueItem}
          onChange={handleChange}
        />
        {showHint && <Hint id={hintId}>{hint}</Hint>}
        {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
      </div>
    </FieldWrapper>
  );
};
